import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1683f730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container-col" }
const _hoisted_2 = { class: "flex-container-col" }
const _hoisted_3 = { class: "flex-container-col" }
const _hoisted_4 = { class: "flex-container-col" }
const _hoisted_5 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_error = _resolveComponent("error")!
  const _component_phone_field = _resolveComponent("phone-field")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_app_dialog = _resolveComponent("app-dialog")!

  return (_openBlock(), _createBlock(_component_app_dialog, {
    title: _ctx.localize('createAccount'),
    onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "request-account-form",
        autocomplete: "on",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_k_input, {
            id: "firstName",
            label: _ctx.localize('firstName'),
            placeholder: _ctx.localize('firstName'),
            name: "given-name",
            autocomplete: "given-name",
            modelValue: _ctx.form.firstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInput('firstName')))
          }, null, 8, ["label", "placeholder", "modelValue"]),
          _withDirectives(_createVNode(_component_error, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.errors.firstName]
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_k_input, {
            id: "lastName",
            label: _ctx.localize('lastName'),
            placeholder: _ctx.localize('lastName'),
            name: "family-name",
            autocomplete: "family-name",
            modelValue: _ctx.form.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.lastName) = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInput('lastName')))
          }, null, 8, ["label", "placeholder", "modelValue"]),
          _withDirectives(_createVNode(_component_error, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.errors.lastName]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_k_input, {
            id: "company",
            label: _ctx.localize('company'),
            placeholder: _ctx.localize('company'),
            name: "organization",
            autocomplete: "organization",
            modelValue: _ctx.form.company,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.company) = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInput('company')))
          }, null, 8, ["label", "placeholder", "modelValue"]),
          _withDirectives(_createVNode(_component_error, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.errors.company]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_k_input, {
            id: "email",
            label: _ctx.localize('email'),
            placeholder: _ctx.localize('email'),
            name: "email",
            autocomplete: "email",
            modelValue: _ctx.form.email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInput('email')))
          }, null, 8, ["label", "placeholder", "modelValue"]),
          _withDirectives(_createVNode(_component_error, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.emailErrorMessage), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.errors.email]
          ])
        ]),
        _createVNode(_component_phone_field, {
          id: "phoneNumber",
          modelValue: _ctx.form.phoneNumber,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.phoneNumber) = $event)),
          required: true
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_k_input, {
            label: _ctx.localize('jobTitle'),
            placeholder: _ctx.localize('jobTitle'),
            name: "organization-title",
            autocomplete: "organization-title",
            modelValue: _ctx.form.jobTitle,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.jobTitle) = $event))
          }, null, 8, ["label", "placeholder", "modelValue"])
        ])
      ], 32),
      _createVNode(_component_dialog_actions_bar, null, {
        default: _withCtx(() => [
          _createVNode(_component_k_button, {
            class: "button-cancel",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close'))),
            disabled: _ctx.isSubmitting
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('cancel')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_k_button, {
            class: "button-green",
            onClick: _ctx.onSubmit,
            disabled: _ctx.isSubmitting
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('submit')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}